import { useLayoutEffect, useRef } from 'react'

import { useGSAP } from '@/composables/useGSAP'

export type SummaryHeroEnterSwirlProps = {
  className?: string
}

export default function SummaryHeroEnterSwirl({ className }: SummaryHeroEnterSwirlProps) {
  const { gsap } = useGSAP()

  const pathOut1Ref = useRef<SVGPathElement>(null)
  const pathOut2Ref = useRef<SVGPathElement>(null)

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap
        .timeline()
        .addLabel('path', 0)
        .fromTo(
          [pathOut1Ref.current, pathOut2Ref.current],
          {
            drawSVG: '100% 100%',
          },
          {
            drawSVG: '0% 100%',
            duration: 0.5,
            stagger: 0.15,
            ease: 'power1.in',
          },
          'path'
        )
        .to(
          [pathOut2Ref.current, pathOut1Ref.current],
          {
            drawSVG: '0% 0%',
            duration: 0.5,
            stagger: 0.15,
            ease: 'power1.inOut',
          },
          'path+=0.65'
        )
    })

    return () => ctx.kill()
  }, [pathOut1Ref, pathOut2Ref, gsap])

  return (
    <svg
      aria-hidden
      className={`SummaryHeroEnterSwirl ${className ? className : ''} absolute top-1/2 -translate-y-1/2 right-[7.5vw] md:-right-[15vw] w-screen pointer-events-none`}
      viewBox='0 0 1440 844'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        ref={pathOut1Ref}
        d='M720 422C1197.5 544.284 1068.16 219.028 1015.59 259.133C955.537 304.945 1283.19 447.67 1440 408.716'
        stroke='currentColor'
        strokeWidth='1.5'
        className='opacity-30'
      />
      <path
        ref={pathOut2Ref}
        d='M720 422C1197.5 544.284 1068.16 219.028 1015.59 259.133C955.537 304.945 1283.19 447.67 1440 408.716'
        stroke='currentColor'
        strokeWidth='1.5'
        className='opacity-100'
      />
    </svg>
  )
}
